import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as FlixxoSVG } from 'assets/brand/avatar.svg'
import { ReactComponent as FacebookSVG } from "assets/social/login-facebook.svg";
import { ReactComponent as AppleSVG } from "assets/social/login-apple.svg";
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { useSession, useModal } from 'hooks';
import scriptjs from "scriptjs";
import useResponsive from 'utils/hooks/useResponsive';
import { Div, Button, Text } from 'ui';
import ModalTemplate from '../components/ModalTemplate';
import { Divider } from './styles'
import { environment } from 'config/environment';


const Welcome = () => {

  const { t } = useTranslation()

  const { Modal: ModalLogin } = useModal('login')
  const { Modal: ModalRegister } = useModal('register')

  const { isMobile } = useResponsive()
  const { loginExternal, isLoggedIn } = useSession();

  const loginFacebook = (response) => {
    if (!response?.accessToken) return

    loginExternal({
      provider: "facebook",
      token: response.accessToken
    })
  }

  const loginApple = () => window.AppleID.auth.signIn()

  const loginFlixxo = () => ModalLogin.open()
  
  const register = () => ModalRegister.open()

  useEffect(() => {
    if (isLoggedIn) ModalLogin.close()
  }, [isLoggedIn])

  useEffect(() => {
    const handleAppleSuccess = (data) => {
      const code = data.detail.authorization.code;
      loginExternal({
        provider: "apple",
        token: code
      })
    }

    const handleAppleError = (error) => {
      console.error('Error apple login: ', error)
    }

    document.addEventListener("AppleIDSignInOnSuccess", handleAppleSuccess);
    document.addEventListener("AppleIDSignInOnFailure", handleAppleError);
    
    return () => {
      document.removeEventListener("AppleIDSignInOnSuccess", handleAppleSuccess);
      document.removeEventListener("AppleIDSignInOnFailure", handleAppleError);
    }
  }, []);


  useEffect(() => {
    scriptjs.get(
      "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js",
      () => {
        const params = {
          clientId: "com.flixxo.play",
          scope: "name email",
          redirectURI: environment.REDIRECT_URI,
          usePopup: true,
        };
        window.AppleID.auth.init(params);
      }
    );
  }, [])

  return  (
    <ModalTemplate>
        <Div
          position={isMobile ? 'unset' : 'absolute'}
          top={-45}
        >
          <FlixxoSVG
            height={isMobile ? 40 : 48}
            width={isMobile ? 40 : 48}
          />
        </Div>

        <Div marginTop={isMobile ? 12 : 24} marginBottom={isMobile ? 12 : 16}>
          <Text
            size={isMobile ? 'xl' : '3xl'}
            weight='semibold'
            color='headline'
          >
            {t('welcomeToFlixxo')}
          </Text>
        </Div>

        <Div textAlign='center'>
          <Text
            size={isMobile ? 'sm' : 'base'}
            as='span'
          >
            {t('discoverBestMicroseries')}
          </Text>
          {' '}
          <Text
            size={isMobile ? 'sm' : 'base'}
            weight='medium'
            color='headline'
            as='span'
          >
            {t('free')}
          </Text>
        </Div>

        <Divider>
          <div />
          <Text size={isMobile ? 'sm' : 'base'}>
            {t('enterWith')}
          </Text>
          <div />
        </Divider>

        <Div display='flex' gap={16} width='100%'>
          <FacebookLogin
            appId={environment.FACEBOOK_ID}
            fields="name,email,picture"
            scope={"public_profile, email"}
            callback={loginFacebook}
            version='15.0'
            redirectUri={environment.REDIRECT_URI}
            responseType='token'
            render={props => (
              <Button
                onClick={props.onClick}
                iconLeft={FacebookSVG}
                variant='secondary'
                size='large'
                isFull
              />
            )}
          />
          <Button
            onClick={loginApple}
            iconLeft={AppleSVG}
            variant='secondary'
            size='large'
            isFull
          />
        </Div>

        <Divider>
          <div />
          <Text size={isMobile ? 'sm' : 'base'}>
            {t('alsoYouCan')}
          </Text>
          <div />
        </Divider>

        <Div display='flex' flexDirection='column' gap={16} width='100%'>
          <Button
            onClick={loginFlixxo}
            size='large'
            isFull
          >
            {t('login')}
          </Button>
          <Button
            onClick={register}
            variant='secondary'
            size='large'
            isFull
          >
            {t('createAccount')}
          </Button>
        </Div>
    </ModalTemplate>
  )
}

export default Welcome